<!--
 * @Description: 订单取消预定
 * @Author: 琢磨先生
 * @Date: 2022-07-11 02:38:50
 * @LastEditors: cts 308360781@qq.com
 * @LastEditTime: 2025-02-17 20:16:29
-->

<template>
  <div v-power="'seller/v1/houseOrder/cancel'">
    <el-dropdown-item
      v-if="order.boolCancelable"
      style="color: #f56c6c"
      @click="onOpenCancel"
      >取消预定</el-dropdown-item
    >
  </div>
  <el-dialog
    title="取消预订"
    v-model="visibleDialog"
    width="800px"
    draggable
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
  >
    <el-form :model="form" ref="form" :rules="rules">
      <!-- 订单金额显示 -->
      <el-table
        class="order_cancel_table"
        ref="table"
        :data="store_list"
        :show-header="false"
        @selection-change="selectionChange"
      >
        <el-table-column label type="selection"></el-table-column>
        <el-table-column label width="400">
          <template #default="scope">
            <div>{{ scope.row.huxing_name }}</div>
            <div>{{ scope.row.house_no }}</div>
          </template>
        </el-table-column>
        <el-table-column label>
          <template #default="scope">
            <div>
              {{ scope.row.checkin_date }} 至 {{ scope.row.checkout_date }}，{{
                scope.row.days
              }}晚
            </div>
            <div>房费：￥{{ scope.row.decimal_amount }}</div>
            <el-form-item label="违约金">
              <el-input
                v-model="scope.row.decimal_break_amount"
                placeholder
                @input="inputBreakAmount"
                clearable
                style="width: 140px"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>

      <el-divider
        v-if="receipt_list.length > 0"
        direction="horizontal"
        content-position="left"
        >在线退款</el-divider
      >
      <el-table
        ref="receiptTable"
        v-if="receipt_list.length > 0"
        :data="receipt_list"
        @selection-change="receiptSelectionChange"
      >
        <el-table-column label type="selection"></el-table-column>
        <el-table-column
          label="类型"
          prop="type_text"
          width="140"
        ></el-table-column>
        <el-table-column
          label="收款金额"
          prop="decimal_amount"
          width="140"
        ></el-table-column>
        <el-table-column label="可退金额">
          <template #default="scope">
            <div>
              可退金额：￥{{
                scope.row.decimal_amount - scope.row.decimal_refund_amount
              }}
            </div>
            <el-form-item label="退款金额">
              <el-input
                v-model="scope.row.input_amount"
                placeholder
                clearable
                style="width: 140px"
                @input="onReceiptInputChange"
              ></el-input>
            </el-form-item>
          </template>
        </el-table-column>
      </el-table>

      <el-form-item label style="margin-top: 20px">
        <el-input
          v-model="form.remark"
          type="textarea"
          rows="4"
          placeholder="请填写取消订单备注信息"
        ></el-input>
      </el-form-item>
    </el-form>
    <div>
      <div>
        <b>违约金：￥{{ current_order.decimal_amount }}</b>
      </div>
      <div class="flex-row flex-between" style="margin-top: 10px">
        <b>已付金额：￥{{ current_order.decimal_receipt_amount }}</b>
        <b>退款总额：￥{{ refundAmount }}</b>
        <b style="color: #f5222d">
          还需付款：￥{{
            current_order.decimal_amount - current_order.decimal_receipt_amount
          }}
        </b>
      </div>
      <div
        style="color: #f5222d; margin-top: 10px"
        v-if="
          refundAmount >
          Math.abs(
            current_order.decimal_receipt_amount - current_order.decimal_amount
          )
        "
      >
        在线退款总额(￥{{ refundAmount }})>已付金额(￥{{
          current_order.decimal_receipt_amount
        }})-违约金(￥{{ current_order.decimal_amount }})=￥{{
          current_order.decimal_receipt_amount - current_order.decimal_amount
        }}、请仔细核对。
      </div>
    </div>

    <template #footer>
      <el-button type="primary" @click="onSubmit" :loading="saving"
        >确认</el-button
      >
    </template>
  </el-dialog>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      visibleDialog: false,
      saving: false,
      current_order: {},
      //可退款的收款记录
      receipt_list: [],
      form: {},
      rules: {},
      store_list: [],
      refundAmount: 0, //计算的退款总额
    };
  },
  props: ["order"],
  emits: ["close"],
  watch: {
    order: {
      handler() {
        this.current_order = Object.assign({}, this.order);
        this.current_order.amount = 0;
        if (this.order.order_stores) {
          this.store_list = this.order.order_stores.filter(
            (o) => o.boolCancelable
          );
        }
        if (this.order && this.order.receipts) {
          this.receipt_list = this.current_order.receipts.filter(
            (x) => x.boolReturnable
          );
          this.receipt_list.forEach((x) => {
            x.input_amount = x.decimal_amount - x.decimal_refund_amount;
          });
        }
      },
      immediate: true,
    },
  },

  methods: {
    /**
     * 打开取消预定
     */
    onOpenCancel() {
      this.visibleDialog = true;
      this.form.order_id = this.current_order.id;
      this.$nextTick(() => {
        this.store_list.forEach((node) => {
          this.$refs.table.toggleRowSelection(node, true);
        });
        console.log(this.$refs.receiptTable);
        this.receipt_list.forEach((x) => {
          this.$refs.receiptTable.toggleRowSelection(x, true);
        });
      });
    },
    /**
     *
     */
    selectionChange(values) {
      //   this.form.order_stores = values;
      this.store_list.forEach((item) => {
        item.is_checked = false;
      });
      values.forEach((item) => {
        item.is_checked = true;
      });
      this.inputBreakAmount();
    },

    /**
     * 违约金输入
     */
    inputBreakAmount() {
      var amount = 0;
      this.store_list.forEach((item) => {
        if (item.is_checked) {
          if (!isNaN(parseFloat(item.decimal_break_amount))) {
            amount += parseFloat(item.decimal_break_amount);
          } else if (item.decimal_break_amount) {
            item.break_amount = "";
          }
        } else {
          amount += item.decimal_amount;
        }
      });
      amount = isNaN(amount) ? 0 : amount;

      this.current_order.decimal_amount = amount;
    },

    /**
     * 选择的退款记录
     * @param {*} values
     */
    receiptSelectionChange(values) {
      this.receipt_list.forEach((item) => {
        item.is_checked = false;
      });
      values.forEach((item) => {
        item.is_checked = true;
      });
      this.calcRefundMoney();
    },

    /**
     * 退款金额输入
     */
    onReceiptInputChange() {
      this.calcRefundMoney();
    },

    /**
     * 计算退款金额
     */
    calcRefundMoney() {
      var amount = 0.0;
      console.log(this.receipt_list);
      this.receipt_list.forEach((item) => {
        if (item.is_checked) {
          if (!isNaN(parseFloat(item.input_amount))) {
            amount += parseFloat(item.input_amount);
          }
        }
      });
      this.refundAmount = amount;
    },

    /**
     * 提交取消预定
     */
    onSubmit() {
      this.form.order_stores = [];
      this.store_list.forEach((item) => {
        if (item.is_checked) {
          this.form.order_stores.push({
            id: item.id,
            decimal_break_amount: isNaN(parseFloat(item.decimal_break_amount))
              ? 0
              : parseFloat(item.decimal_break_amount),
          });
        }
      });
      if (this.form.order_stores.length <= 0) {
        this.$message.info("至少选择一条房间数据");
        return;
      }
      this.form.receipt_list = this.receipt_list.map((x) => {
        return {
          id: x.id,
          decimal_return_amount: x.input_amount,
        };
      });
      this.saving = true;
      this.$http
        .post("seller/v1/houseOrder/cancel", this.form)
        .then((res) => {
          if (res.code == 0) {
            this.$message.success(res.msg);
            this.$emit("close");
            this.visibleDialog = false;
          }
        })
        .finally(() => {
          this.saving = false;
        });
    },
  },
};
</script>

<style>
.order_cancel_table.el-table td.el-table__cell,
.order_cancel_table.el-table th.el-table__cell.is-leaf {
  border: none;
}
</style>
